<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler mobile/>
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="img/brand/logo.svg"
          width="89"
          height="25"
          alt="Gt Alarm"
        >
        <img
          class="navbar-brand-minimized"
          src="img/brand/logo_mini.png"
          width="30"
          height="30"
          alt="Gt Alarm"
        >
      </b-link>

      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
          <strong>Crediti:</strong>
          {{ user.credits }}
        </b-nav-item>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>

      <AsideToggler mobile/>
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb style="margin-bottom: 4px;" :list="list"/>
        <div style="padding: 0 4px;">
          <router-view></router-view>
        </div>
      </main>

      <aside class="aside-menu" style="overflow-y: auto; ">
        <b-navbar-nav class="mobile-user-menu d-block d-md-none">
          <DefaultHeaderDropdownAccnt/>
          <b-nav-item>
            <strong>Crediti:</strong>
            {{ user.credits }}
          </b-nav-item>
        </b-navbar-nav>

        <DefaultAside style="overflow-y: auto; "/>
      </aside>
    </div>

    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://www.gtalarm.it" target="_blank">GT Alarm</a>
        <span class="ml-1">&copy; 2018</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Utente: {{ subuser.firstName + ' ' + subuser.lastName }}</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import { mapGetters } from "vuex";
import Pusher from "pusher-js";
import "jquery";
import toastr from "toastr"; // https://github.com/CodeSeven/toastr
import "toastr/build/toastr.min.css";
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import {
  UPDATE_CONTRACT,
  UPDATE_REQUEST,
  UPDATE_CREDITS
} from "@/store/mutation-types";

function toast({ title, message, type, timeout, cb, position }) {
  //we've added 'position' here
  if (type === VueNotifications.types.warn) type = "warning";
  if (position) toastr.options.positionClass = position; //Ve've set position here
  return toastr[type](message, title, { timeOut: timeout });
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

// VueNotifications.setPluginOptions(options)
Vue.use(VueNotifications, options);

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  created() {
    this.$store
      .dispatch("fleets")
      .then(() => console.log("fleets loaded"))
      .catch(err => {
        console.log(err);
        this.$store.dispatch("logout").then(() => this.$router.push("/login"));
      });

    this.$store
      .dispatch("user")
      .then(() => {
        console.log("user loaded");

        this.pusherSubscribe();
      })
      .catch(err => console.log(err));

    this.$store
      .dispatch("subuser")
      .then(() => {
        console.log("subuser loaded");

        let passwordExpired = this.passwordExpirationCheck();

        if (passwordExpired) this.$router.push("/changepwd");
      })
      .catch(err => console.log(err));
  },
  beforeDestroy() {
    this.pusher.unsubscribe(`private-user-${this.$store.state.user.id}`);
  },
  data() {
    return {
      navItems: nav.items,
      pusher: null
    };
  },
  methods: {
    commandText(data) {
      if (data.command === "LOCATE") {
        return "Localizza";
      } else if (
        data.command === "ENGINE_IMMOBILIZER" &&
        data.parameters === "1"
      ) {
        return "Attiva BM";
      } else if (
        data.command === "ENGINE_IMMOBILIZER" &&
        data.parameters === "2"
      ) {
        return "Disattiva BM";
      } else if (
        (data.command === "ALARM" || data.command === "ALARM_SEMS") &&
        data.parameters === "1"
      ) {
        return "Attiva Allarme";
      } else if (
        (data.command === "ALARM" || data.command === "ALARM_SEMS") &&
        data.parameters === "2"
      ) {
        return "Disattiva Allarme";
      } else {
        return "???";
      }
    },
    pusherSubscribe() {
      this.pusher = new Pusher("2a0b5c63810861daae5d", {
        authEndpoint: "https://api.gtalarm.it/pusher/auth",
        forceTLS: true
      });
      this.pusher.subscribe(`private-user-${this.$store.state.user.id}`);
      this.pusher.bind("livemonitorChanged", data => {
        console.log("livemonitorChanged");
        this.$store.commit(UPDATE_CONTRACT, data);
      });
      this.pusher.bind("creditsChanged", data => {
        console.log("creditsChanged");
        this.showInfoMsg({
          title: "Consumo crediti:",
          message: `${data.amount}`
        });
        this.$store.commit(UPDATE_CREDITS, data.credits);
      });
      this.pusher.bind("requestChanged", data => {
        console.log("requestChanged");
        const contract = this.contract(data.contractId);
        if (contract) {
          if (data.status === 3) {
            this.showSuccessMsg({
              title: `Veicolo ${contract.alias}`,
              message: `Comando ${this.commandText(
                data
              )} eseguito correttamente`
            });
          } else if (data.status === 8) {
            this.showWarnMsg({
              title: `Veicolo ${contract.alias}`,
              message: `Comando ${this.commandText(data)} scaduto`
            });
          } else if (data.status === 8) {
            this.showErrorMsg({
              title: `Veicolo ${contract.alias}`,
              message: `Comando ${this.commandText(data)} non eseguito`
            });
          }
        }
        this.$store.commit(UPDATE_REQUEST, data);
      });
    },
    passwordExpirationCheck() {
      console.log("Check password expiration");

      if (this.$store.state.subuser.passwordExpired) {
        return true;
      }
    }
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    ...mapGetters(["user", "subuser", "contract"])
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "",
      message: "",
      position: "toast-bottom-right"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "",
      message: "",
      position: "toast-bottom-right"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "",
      message: "",
      position: "toast-bottom-right"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "",
      message: "",
      position: "toast-bottom-right"
    }
  }
};
</script>
